import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { post } from './AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import { FaEye } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';

function ViewOnlineProfileEdit({
  onlineProfileData,
  setProfileData,
  onClose,
  openOnlineProfileView,
}) {
  const { user } = useSelector((store) => store.auth);
  const [enableOnlineProfile, setEnableOnlineProfile] = useState(false);
  const [enableOpenSchedule, setEnableOpenSchedule] = useState(false);
  const [aboutMe, setAboutMe] = useState('');
  const [profilePicture, setProfilePicture] = useState(null);
  const [profilePreview, setProfilePreview] = useState('');

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedInsurances, setSelectedInsurances] = useState([]);

  const [newTov, setNewTov] = useState('');
  const [returnTov, setReturnTov] = useState('');

  useEffect(() => {
    if (!onlineProfileData) return;

    setEnableOnlineProfile(
      onlineProfileData.enableOnlineProfile === '0' ||
        onlineProfileData.enableOnlineProfile === 0
        ? false
        : true,
    );
    setEnableOpenSchedule(
      onlineProfileData.enableOpenSchedule === '0' ||
        onlineProfileData.enableOpenSchedule === 0
        ? false
        : true,
    );
    setAboutMe(onlineProfileData.aboutMe || '');

    setProfilePreview(
      onlineProfileData.userProfilePic || '/images/default-avatar.png',
    );

    setSelectedServices(onlineProfileData.selectedServiceIds || []);
    setSelectedLocations(onlineProfileData.selectedLocationIds || []);
    setSelectedInsurances(onlineProfileData.selectedInsuranceIds || []);

    setNewTov(onlineProfileData.tov_new || '');
    setReturnTov(onlineProfileData.tov_followup || '');
  }, [onlineProfileData]);

  const toggleSelection = (id, list, setter) => {
    if (list.includes(id)) {
      setter(list.filter((item) => item !== id));
    } else {
      setter([...list, id]);
    }
  };

  const handleProfilePicture = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setProfilePicture(file);
    setProfilePreview(URL.createObjectURL(file));
  };

  const handleSave = async () => {
    const formData = new FormData();

    formData.append('userId', user?.id);
    formData.append('enable_online_profile', enableOnlineProfile ? 1 : 0);
    formData.append('enable_open_schedule', enableOpenSchedule ? 1 : 0);

    formData.append('about_me', aboutMe);
    formData.append('providerNewTov', newTov);
    formData.append('providerReturnTov', returnTov);
    formData.append('defaultAppDuration', 15);

    // selectedServices.forEach((id) => formData.append('services[]', id));
    // selectedLocations.forEach((id) => formData.append('locations[]', id));
    // selectedInsurances.forEach((id) => formData.append('insurances[]', id));

    formData.append('services', JSON.stringify(selectedServices));
    formData.append('locations', JSON.stringify(selectedLocations));
    formData.append('insurances', JSON.stringify(selectedInsurances));

    if (profilePicture) {
      formData.append('profile_picture', profilePicture);
    }

    try {
      const response = await post('api/auth/saveOnlineProfile', formData, true);
      if (response.status === 200) {
        onClose();
        openOnlineProfileView();
      }
    } catch (err) {
      setUiMessage('err', err?.message);
    }
  };

  return (
    <div className="modalBackground">
      <div
        className="popup__content lg scrollbar"
        style={{ transform: 'scale(1)' }}
      >
        <div className="popup-header flex justify-between">
          <h2 className="fw-500 mb-3">My Online Profile</h2>

          <span
            className="close-btn"
            onClick={() => {
              onClose();
              setProfileData(null);
            }}
          >
            {/* &times; */}
            <ImCross />
          </span>
        </div>

        <div className="popup-body">
          <div className="onlinePresence">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h2 className="fs-lg fw-600 mb-4">
                  My Online Profile - {onlineProfileData?.providerName}
                </h2>
              </div>

              <a
                href={onlineProfileData?.previewProfileUrl}
                target="_blank"
                rel="noreferrer"
              >
                <button
                  type="button"
                  className="border border-lightgray bg-white rounded-md flex items-center gap-2 px-2 py-2 cursor-pointer"
                >
                  {/* <img src="/images/assets/images/eye.svg" width={14} alt="" /> */}
                  <FaEye />
                  Preview Profile
                </button>
              </a>
            </div>

            {/* Profile Visibility */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">
                Profile Visibility
              </h3>

              <div className="flex items-center justify-between">
                <div className="flex flex-col gap-2 pt-3">
                  <span className="text-black fs-sm">
                    Enable Online Profile
                  </span>

                  <span className="grey fs-xs">
                    Make your profile visible to potential patients
                  </span>
                </div>

                <label className="toggleSwitch">
                  <input
                    type="checkbox"
                    checked={enableOnlineProfile}
                    onChange={(e) => setEnableOnlineProfile(e.target.checked)}
                  />

                  <span className="slider"></span>
                </label>
              </div>

              <div className="hr my-4"></div>

              <div className="flex items-center justify-between">
                <div className="flex flex-col gap-2">
                  <span className="text-black fs-sm">
                    Open schedule for online Appointment
                  </span>

                  <span className="grey fs-xs">
                    Allow patients to book appointments online
                  </span>
                </div>

                <label className="toggleSwitch">
                  <input
                    type="checkbox"
                    checked={enableOpenSchedule}
                    onChange={(e) => setEnableOpenSchedule(e.target.checked)}
                  />

                  <span className="slider"></span>
                </label>
              </div>
            </div>

            {/* Profile Picture */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">
                Profile Picture & About
              </h3>

              <div className="flex flex-col gap-8">
                <div className="onlinePresence__card-profile flex flex-col gap-4">
                  <div className="onlinePresence__card-profile-section flex flex-col gap-2 pt-3">
                    <div className="fs-sm text-dark mb-3">Profile Picture</div>

                    <div className="flex items-center gap-6">
                      <div className="onlinePresence__card-avatar overflow-hidden rounded-full">
                        <img src={profilePreview} alt="Profile" />
                      </div>

                      <label className="onlinePresence__card-upload cursor-pointer border border-lightgray rounded-md px-2 py-1 fs-xxs text-dark">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleProfilePicture}
                        />
                        <img src="./images/upload.svg" width={12} alt="" />
                        Upload Picture
                      </label>
                    </div>
                  </div>
                </div>

                {/* About */}

                <div className="onlinePresence__card-about">
                  <div className="mb-3">
                    <label className="pb-1 fs-xs">About Me</label>

                    <textarea
                      className="form-control"
                      style={{ minHeight: 160 }}
                      value={aboutMe}
                      onChange={(e) => setAboutMe(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Default Visit Type */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">
                Default Type of Visit
              </h3>

              <div className="flex items-center gap-3 pt-3">
                <div className="text-black fs-sm">New pt default:</div>

                <select
                  value={newTov}
                  onChange={(e) => setNewTov(e.target.value)}
                >
                  <option value=""></option>

                  {Object.entries(onlineProfileData?.tovDataArray || {}).map(
                    ([key, value]) => (
                      //   <option key={key} value={key}>
                      //     {value}
                      //   </option>
                      <option key={key} value={value.id}>
                        {value.name}
                      </option>
                    ),
                  )}
                </select>
              </div>

              <div className="flex items-center gap-3 pt-3">
                <div className="text-black fs-sm">Returning pt default:</div>

                <select
                  value={returnTov}
                  onChange={(e) => setReturnTov(e.target.value)}
                >
                  <option value=""></option>

                  {Object.entries(onlineProfileData?.tovDataArray || {}).map(
                    ([key, value]) => (
                      //   <option key={key} value={key}>
                      //     {value}
                      //   </option>
                      <option key={key} value={value.id}>
                        {value.name}
                      </option>
                    ),
                  )}
                </select>
              </div>

              <input type="hidden" value={15} />
            </div>

            {/* Services Offered */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black fs-sm fw-600">Service Offered</h3>

              <p className="grey fs-xs leading-normal mb-3 pt-2">
                Select the services you offer from the list below:
              </p>

              <div className="onlinePresence__card-grid">
                {(onlineProfileData?.clinicServicesList || []).map(
                  (service) => (
                    <div
                      key={service.id}
                      className="border border-lightgray rounded-lg p-3 flex gap-2"
                    >
                      <label className="flex items-start gap-1">
                        <input
                          type="checkbox"
                          checked={selectedServices.includes(service.id)}
                          onChange={() =>
                            toggleSelection(
                              service.id,
                              selectedServices,
                              setSelectedServices,
                            )
                          }
                        />
                      </label>

                      <div className="flex flex-col gap-1">
                        <h4 className="fs-xs">{service.service_name}</h4>

                        <p className="fs-xxs text-gray leading-normal">
                          {service.service_description}
                        </p>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>

            {/* Practice Locations */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black fs-sm fw-600">Practice Locations</h3>

              <p className="grey fs-xs leading-normal mb-3 pt-2">
                Select the practice locations below:
              </p>

              <div className="onlinePresence__card-grid onlinePresence__card-grid--one">
                {(onlineProfileData?.clinicLocationsList || []).map(
                  (location) => (
                    <div
                      key={location.id}
                      className="border border-lightgray rounded-lg p-3 flex gap-2"
                    >
                      <label className="flex items-start gap-1">
                        <input
                          type="checkbox"
                          checked={selectedLocations.includes(location.id)}
                          onChange={() =>
                            toggleSelection(
                              location.id,
                              selectedLocations,
                              setSelectedLocations,
                            )
                          }
                        />
                      </label>

                      <div className="flex flex-col gap-1">
                        <h4 className="fs-xs">{location.location_code}</h4>

                        <p className="fs-xxs text-gray">
                          {location.address_1} {location.city},{' '}
                          {location.stateCode} - {location.zip}
                        </p>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>

            {/* Accepted Insurance */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black fs-sm fw-600">Accepted Insurance</h3>

              <p className="grey fs-xs leading-normal mb-3 pt-2">
                Select Insurance Providers
              </p>

              <div className="onlinePresence__card-grid onlinePresence__card-grid--three">
                {(onlineProfileData?.clinicInsuranceList || []).map(
                  (insurance) => (
                    <div
                      key={insurance.id}
                      className="border border-lightgray rounded-lg p-3 flex gap-2"
                    >
                      <label className="flex items-center gap-1 pb-0">
                        <input
                          type="checkbox"
                          checked={selectedInsurances.includes(insurance.id)}
                          onChange={() =>
                            toggleSelection(
                              insurance.id,
                              selectedInsurances,
                              setSelectedInsurances,
                            )
                          }
                        />

                        <span className="fw-600">
                          {insurance.insurance_company_name}
                        </span>
                      </label>
                    </div>
                  ),
                )}
              </div>
            </div>

            {/* Footer */}

            <div className="flex justify-end gap-4">
              <button
                type="button"
                className="btn-outline-dark rounded-md"
                onClick={() => {
                  openOnlineProfileView();
                  onClose();
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn-black rounded-md flex items-center gap-2"
                onClick={handleSave}
              >
                <svg
                  fill="#ffffff"
                  width="14"
                  height="14"
                  viewBox="0 0 502 502"
                >
                  <path d="M492,0H10C4.477,0,0,4.477,0,10v424c0,2.652,1.054,5.196,2.929,7.071l58,58C62.804,500.946,65.348,502,68,502h424c5.523,0,10-4.477,10-10V10C502,4.477,497.523,0,492,0zM86,20h330v240H86V20zM194.045,482H158.06v-67.589h35.985V482zM313.239,482h-99.194v-77.589c0-5.523-4.477-10-10-10H148.06c-5.523,0-10,4.477-10,10V482h-17.925V381h193.104V482zM381.866,482h-48.627V381h48.627V482zM482,482h-80.134V371c0-5.523-4.477-10-10-10h-68.627H110.134c-5.523,0-10,4.477-10,10v111H72.142L20,429.858V20h46v250c0,5.523,4.477,10,10,10h350c5.523,0,10-4.477,10-10V20h46V482z" />
                  <path d="M367.5,62H345c-5.523,0-10,4.477-10,10s4.477,10,10,10h22.5c5.523,0,10-4.477,10-10S373.023,62,367.5,62z" />
                  <path d="M134.5,82H299c5.523,0,10-4.477,10-10s-4.477-10-10-10H134.5c-5.523,0-10,4.477-10,10S128.977,82,134.5,82z" />
                  <path d="M367.5,129h-233c-5.523,0-10,4.477-10,10s4.477,10,10,10h233c5.523,0,10-4.477,10-10S373.023,129,367.5,129z" />
                  <path d="M367.5,196h-233c-5.523,0-10,4.477-10,10s4.477,10,10,10h233c5.523,0,10-4.477,10-10S373.023,196,367.5,196z" />
                </svg>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewOnlineProfileEdit;
